export default __webpack_public_path__ + "static/media/Holiday Inn and Staybridge.0e37165c.jpg";